/**
 * Generated by scripts/module-catalog.mjs from the application's own OpenAPI
 * document. Do not edit: run `npm run api`.
 */

export type GeneratedFilter = { name: string; choices: string[] }

export type GeneratedList = {
  /** The registered route, prefix included — also the key for the help panel. */
  path: string
  summary: string
  description: string
  columns: string[]
  filters: GeneratedFilter[]
}

export const generatedLists: GeneratedList[] = [
  {
    "path": "/changes/court",
    "summary": "My Court",
    "description": "Everything in this module waiting on the signed-in user.",
    "columns": [
      "action_key",
      "change_event_id",
      "due_on",
      "number",
      "overdue",
      "reason_key",
      "record_id",
      "record_kind",
      "state",
      "title"
    ],
    "filters": []
  },
  {
    "path": "/changes/events",
    "summary": "List Events",
    "description": "The change register: filtered, searched, sorted and resumable.",
    "columns": [
      "csi_division_id",
      "currency",
      "id",
      "manager_person_id",
      "number",
      "occurred_at",
      "origin_kind",
      "project_id",
      "quantity",
      "quantity_unit",
      "reason",
      "rom_cost_amount",
      "rom_revenue_amount",
      "state",
      "title"
    ],
    "filters": [
      {
        "name": "state",
        "choices": [
          "draft",
          "open",
          "closed",
          "void"
        ]
      }
    ]
  },
  {
    "path": "/changes/schedule/time-impacts",
    "summary": "Approved Time Impacts",
    "description": "The hook the schedule module reads: approved time, and where it lands.",
    "columns": [
      "approved_at",
      "change_event_id",
      "change_order_id",
      "number",
      "title",
      "working_days"
    ],
    "filters": []
  },
  {
    "path": "/correspondence/clarifications",
    "summary": "List Clarifications",
    "description": "The clarifications register (CM-COR-05).",
    "columns": [
      "body",
      "contract_document",
      "id",
      "number",
      "occurred_at",
      "owner_person_id",
      "settled_at",
      "settled_by_person_id",
      "settled_note",
      "spec_section_id",
      "status",
      "title",
      "value_amount",
      "value_impact"
    ],
    "filters": [
      {
        "name": "status",
        "choices": [
          "open",
          "accepted",
          "rejected",
          "withdrawn",
          "incorporated"
        ]
      }
    ]
  },
  {
    "path": "/correspondence/court",
    "summary": "My Court",
    "description": "Everything in this module waiting on the signed-in user.",
    "columns": [
      "action_key",
      "due_on",
      "item_id",
      "number",
      "overdue",
      "reason_key",
      "state",
      "subject"
    ],
    "filters": []
  },
  {
    "path": "/correspondence/deadlines",
    "summary": "Deadline Report",
    "description": "The notice deadline report, and the response countdown beside it.",
    "columns": [
      "at_risk",
      "due_at",
      "due_on",
      "item_id",
      "kind",
      "number",
      "overdue",
      "status",
      "subject",
      "type_code",
      "working_days_remaining"
    ],
    "filters": []
  },
  {
    "path": "/correspondence/items",
    "summary": "List Items",
    "description": "The correspondence register: filtered, searched, sorted, and resumable.",
    "columns": [
      "direction",
      "id",
      "issued_on",
      "manager_person_id",
      "notice_deadline_on",
      "number",
      "response_due_on",
      "status",
      "subject",
      "thread_root_id",
      "type_id"
    ],
    "filters": [
      {
        "name": "status",
        "choices": [
          "draft",
          "sent",
          "received",
          "response_due",
          "responded",
          "closed"
        ]
      },
      {
        "name": "direction",
        "choices": [
          "outbound",
          "inbound"
        ]
      }
    ]
  },
  {
    "path": "/correspondence/notice-preferences",
    "summary": "List Notice Preferences",
    "description": "Your own settings on this project (CM-COR-07).",
    "columns": [
      "id",
      "mode",
      "person_id",
      "verb"
    ],
    "filters": []
  },
  {
    "path": "/correspondence/types",
    "summary": "List Types",
    "description": "The types this project raises correspondence under.",
    "columns": [
      "accepted_by_person_id",
      "allows_inbound",
      "allows_outbound",
      "category",
      "code",
      "day_count",
      "governs",
      "id",
      "is_active",
      "name",
      "notice_period_days",
      "period_clause",
      "project_id",
      "requires_response",
      "response_days",
      "seeded_from"
    ],
    "filters": []
  },
  {
    "path": "/dailylog/companies",
    "summary": "List Company Requests",
    "description": "",
    "columns": [
      "company_id",
      "id",
      "kind",
      "project_id",
      "proposed_name",
      "requested_by_person_id",
      "state"
    ],
    "filters": []
  },
  {
    "path": "/dailylog/days",
    "summary": "List Days",
    "description": "",
    "columns": [
      "id",
      "issue_id",
      "log_date",
      "project_id",
      "revision",
      "signed_at",
      "signed_by_person_id",
      "state"
    ],
    "filters": []
  },
  {
    "path": "/directory/history",
    "summary": "Read History",
    "description": "Who changed the directory, what they changed, for whom, and on which box.",
    "columns": [
      "actor_id",
      "actor_name",
      "entity_id",
      "entity_type",
      "event_id",
      "occurred_at",
      "origin",
      "reason",
      "scope",
      "summary_key",
      "verb"
    ],
    "filters": []
  },
  {
    "path": "/directory/invitations",
    "summary": "List Invitations",
    "description": "What is outstanding, and what happened to what is not.",
    "columns": [
      "accepted_person_id",
      "company_id",
      "display_name",
      "email",
      "expires_at",
      "id",
      "job_title",
      "language",
      "note",
      "project_id",
      "status",
      "template_id"
    ],
    "filters": []
  },
  {
    "path": "/drawings/comparisons",
    "summary": "List Comparisons",
    "description": "The comparisons this project has, newest first, without their clouds.",
    "columns": [
      "ai_executor",
      "ai_model",
      "ai_prompt_version",
      "clouds",
      "created_at",
      "dismissed",
      "from_revision_id",
      "id",
      "narrative_state",
      "sheet_id",
      "to_revision_id"
    ],
    "filters": []
  },
  {
    "path": "/drawings/links",
    "summary": "List Links",
    "description": "Callout links, filterable by state so the unverified ones can be worked",
    "columns": [
      "confidence",
      "detail_reference",
      "from_revision_id",
      "id",
      "page",
      "source",
      "to_sheet_id",
      "verification_state"
    ],
    "filters": []
  },
  {
    "path": "/drawings/offline-manifest",
    "summary": "Offline Manifest",
    "description": "What a field device must hold to work with no network.",
    "columns": [
      "byte_size",
      "content_type",
      "discipline",
      "number",
      "page",
      "revision_id",
      "sha256",
      "sheet_id",
      "storage_key",
      "title"
    ],
    "filters": []
  },
  {
    "path": "/drawings/review-sessions",
    "summary": "List Review Sessions",
    "description": "Every review session on the job, running ones first, then the archive.",
    "columns": [
      "closed_at",
      "closed_by_person_id",
      "comment_count",
      "ends_at",
      "id",
      "name",
      "opened_at",
      "opened_by_name",
      "opened_by_person_id",
      "page_count",
      "participant_count",
      "pinned_sha256",
      "project_id",
      "set_id",
      "set_name",
      "set_revision_label",
      "status"
    ],
    "filters": []
  },
  {
    "path": "/drawings/series",
    "summary": "List Series",
    "description": "The project's named drawing sets, by name.",
    "columns": [
      "created_at",
      "current_issuance_id",
      "id",
      "issuance_count",
      "name",
      "project_id",
      "published_count"
    ],
    "filters": []
  },
  {
    "path": "/drawings/sets",
    "summary": "List Sets",
    "description": "",
    "columns": [
      "area",
      "current_page",
      "current_step",
      "has_text_layer",
      "id",
      "issued_on",
      "name",
      "page_count",
      "pages_done",
      "pages_failed",
      "pages_pending",
      "percent",
      "project_id",
      "revision_label",
      "series_id",
      "state",
      "status"
    ],
    "filters": []
  },
  {
    "path": "/drawings/sheets",
    "summary": "List Sheets",
    "description": "The current set: one row per sheet, at its current revision.",
    "columns": [
      "area",
      "discipline",
      "feet_per_inch",
      "is_current",
      "number",
      "page",
      "page_height_in",
      "page_width_in",
      "revision_id",
      "revision_label",
      "scale_text",
      "sheet_id",
      "source_storage_key",
      "superseded_notice",
      "title"
    ],
    "filters": []
  },
  {
    "path": "/engage/feed",
    "summary": "Activity Feed",
    "description": "The ambient feed: read-only, no badges, nothing that demands action.",
    "columns": [
      "actor_id",
      "entity_id",
      "entity_type",
      "event_id",
      "module",
      "occurred_at",
      "origin",
      "origin_seq",
      "recorded_at",
      "summary_key",
      "verb"
    ],
    "filters": []
  },
  {
    "path": "/engage/notifications",
    "summary": "Notifications",
    "description": "Your items — the only thing that ever buzzes a device.",
    "columns": [
      "access",
      "buzz",
      "entity_id",
      "entity_type",
      "fell_back",
      "id",
      "language",
      "module",
      "occurred_at",
      "read_at",
      "text",
      "trigger",
      "trigger_name"
    ],
    "filters": []
  },
  {
    "path": "/equipment/assets",
    "summary": "List Assets",
    "description": "The project's register, by tag.",
    "columns": [
      "description",
      "equipment_type",
      "id",
      "location_id",
      "manufacturer",
      "model_number",
      "parent_id",
      "parent_tag",
      "project_id",
      "serial_number",
      "status",
      "tag",
      "warranty_ends_on"
    ],
    "filters": [
      {
        "name": "status",
        "choices": [
          "planned",
          "delivered",
          "installed",
          "commissioned",
          "handed_over"
        ]
      }
    ]
  },
  {
    "path": "/example/notes",
    "summary": "List Notes",
    "description": "",
    "columns": [
      "body",
      "id",
      "occurred_at",
      "project_id",
      "retracted"
    ],
    "filters": []
  },
  {
    "path": "/feedback/reports",
    "summary": "My Reports",
    "description": "What this person reported, and where each one got to.",
    "columns": [
      "app_version",
      "assigned_person_id",
      "body",
      "closed_at",
      "created_by_person_id",
      "delivery_mode",
      "device_platform",
      "duplicate_of_id",
      "help_topic_id",
      "id",
      "kind",
      "module_code",
      "module_version",
      "occurred_at",
      "origin_node",
      "priority",
      "project_id",
      "reference",
      "reopen_count",
      "resolution_note",
      "route",
      "severity",
      "source",
      "status",
      "was_online"
    ],
    "filters": []
  },
  {
    "path": "/feedback/triage",
    "summary": "Triage Board",
    "description": "Every report on the project, filtered.",
    "columns": [
      "app_version",
      "assigned_person_id",
      "body",
      "closed_at",
      "created_by_person_id",
      "delivery_mode",
      "device_platform",
      "duplicate_of_id",
      "help_topic_id",
      "id",
      "kind",
      "module_code",
      "module_version",
      "occurred_at",
      "origin_node",
      "priority",
      "project_id",
      "reference",
      "reopen_count",
      "resolution_note",
      "route",
      "severity",
      "source",
      "status",
      "was_online"
    ],
    "filters": []
  },
  {
    "path": "/field/media",
    "summary": "List Media",
    "description": "Every media record on a project, pending transfers included.",
    "columns": [
      "byte_size",
      "bytes_received",
      "caption",
      "captured_at",
      "content_state",
      "filename",
      "idempotency_key",
      "media_id"
    ],
    "filters": []
  },
  {
    "path": "/fieldreport/reports",
    "summary": "List Reports",
    "description": "The project's reports, newest date first.",
    "columns": [
      "created_by_person_id",
      "has_final_copy",
      "id",
      "observation_count",
      "prepared_by",
      "project_id",
      "report_date",
      "report_number",
      "title"
    ],
    "filters": []
  },
  {
    "path": "/fieldreport/schedules",
    "summary": "List Schedules",
    "description": "Every schedule imported on the project, newest first. The newest is current.",
    "columns": [
      "activity_count",
      "data_date",
      "filename",
      "format",
      "id",
      "imported_at",
      "is_current",
      "name",
      "project_id"
    ],
    "filters": []
  },
  {
    "path": "/markup/log",
    "summary": "Markup Log",
    "description": "Every document on this job with markup this reader may see.",
    "columns": [
      "label",
      "target_id",
      "target_module",
      "target_type"
    ],
    "filters": []
  },
  {
    "path": "/markup/stamps",
    "summary": "List Stamps",
    "description": "The review stamp palette for this project (CM-MKP-07).",
    "columns": [
      "code",
      "is_active",
      "is_default",
      "label",
      "meaning",
      "ordinal"
    ],
    "filters": []
  },
  {
    "path": "/meetings/actions",
    "summary": "List Actions",
    "description": "Open actions by assignee — the report the specification asks for.",
    "columns": [
      "agenda_item_id",
      "assignee_company_id",
      "assignee_person_id",
      "body",
      "completed_at",
      "completed_by_person_id",
      "completion_source",
      "due_on",
      "id",
      "meeting_id",
      "reopened_count",
      "state"
    ],
    "filters": [
      {
        "name": "state",
        "choices": [
          "open",
          "done",
          "cancelled"
        ]
      }
    ]
  },
  {
    "path": "/meetings/carried-forward",
    "summary": "Carried Forward Register",
    "description": "Everything that keeps coming back, worst first.",
    "columns": [
      "agenda_item_id",
      "carried_from_known",
      "carried_from_meeting_id",
      "carry_count",
      "meeting_date",
      "meeting_id",
      "meeting_number",
      "title"
    ],
    "filters": []
  },
  {
    "path": "/meetings/court",
    "summary": "My Court",
    "description": "Everything in this module waiting on the signed-in user.",
    "columns": [
      "action_id",
      "action_key",
      "body",
      "due_on",
      "meeting_id",
      "meeting_number",
      "overdue",
      "reason_key",
      "state"
    ],
    "filters": []
  },
  {
    "path": "/meetings/occurrences",
    "summary": "List Meetings",
    "description": "The meeting log: filtered, searched, sorted and resumable.",
    "columns": [
      "chair_person_id",
      "end_time",
      "id",
      "location",
      "meeting_date",
      "number",
      "open_actions",
      "open_items",
      "project_id",
      "published_revision",
      "series_id",
      "start_time",
      "state",
      "time_zone",
      "title"
    ],
    "filters": [
      {
        "name": "state",
        "choices": [
          "scheduled",
          "held",
          "published",
          "cancelled"
        ]
      }
    ]
  },
  {
    "path": "/meetings/series",
    "summary": "List Series",
    "description": "Every recurring meeting on the project.",
    "columns": [
      "cadence",
      "chair_person_id",
      "default_location",
      "default_start_time",
      "ends_on",
      "id",
      "is_active",
      "kind",
      "month_day",
      "month_week",
      "month_weekday",
      "occurrence_limit",
      "project_id",
      "starts_on",
      "time_zone",
      "title"
    ],
    "filters": []
  },
  {
    "path": "/photos/albums",
    "summary": "List Albums",
    "description": "The project's albums by name, with how many photographs each holds.",
    "columns": [
      "cover_media_id",
      "id",
      "media_count",
      "name",
      "project_id"
    ],
    "filters": []
  },
  {
    "path": "/photos/media",
    "summary": "List Media",
    "description": "The project's photographs, newest first, narrowed the way the screen asks.",
    "columns": [
      "byte_size",
      "can_redo_thumbnail",
      "caption",
      "caption_source",
      "caption_version",
      "captured_at",
      "captured_on",
      "content_type",
      "created_by_person_id",
      "deleted_at",
      "deleted_by_person_id",
      "gps_policy",
      "has_thumbnail",
      "id",
      "latitude",
      "location_id",
      "longitude",
      "project_id",
      "state",
      "thumbnail_version",
      "thumbnail_withheld",
      "trade",
      "uploaded_at"
    ],
    "filters": []
  },
  {
    "path": "/photos/pending",
    "summary": "Pending Uploads",
    "description": "Records whose image has not arrived — the queue, with progress visible.",
    "columns": [
      "captured_at",
      "created_by_person_id",
      "id"
    ],
    "filters": []
  },
  {
    "path": "/repository/documents",
    "summary": "List Documents",
    "description": "The project's index: every document the reader may open, in every folder.",
    "columns": [
      "created_by_person_id",
      "current",
      "document_type",
      "folder_id",
      "id",
      "in_private_folder",
      "name",
      "project_id",
      "version_count"
    ],
    "filters": []
  },
  {
    "path": "/rfi/court",
    "summary": "My Court",
    "description": "Everything in this module waiting on the signed-in user.",
    "columns": [
      "action_key",
      "due_on",
      "number",
      "overdue",
      "reason_key",
      "rfi_id",
      "state",
      "subject"
    ],
    "filters": []
  },
  {
    "path": "/rfi/rfis",
    "summary": "List Rfis",
    "description": "The RFI log: filtered, searched, sorted, and resumable.",
    "columns": [
      "cost_amount",
      "cost_impact",
      "due_on",
      "due_on_source",
      "id",
      "is_private",
      "manager_person_id",
      "number",
      "occurred_at",
      "project_id",
      "revision_no",
      "route_role_code",
      "schedule_days",
      "schedule_impact",
      "state",
      "subject",
      "workflow_step_due_on",
      "workflow_step_order",
      "workflow_template_id"
    ],
    "filters": [
      {
        "name": "state",
        "choices": [
          "draft",
          "open",
          "answered",
          "closed_draft",
          "closed",
          "reopened"
        ]
      }
    ]
  },
  {
    "path": "/rfi/workflow-templates",
    "summary": "List Templates",
    "description": "The project's RFI workflow templates, the default first.",
    "columns": [
      "applies_to_mep",
      "id",
      "is_default",
      "is_retired",
      "name",
      "occurred_at",
      "project_id"
    ],
    "filters": []
  },
  {
    "path": "/schedule/calendars",
    "summary": "List Calendars",
    "description": "",
    "columns": [
      "id",
      "is_default",
      "name",
      "project_id",
      "workweek"
    ],
    "filters": []
  },
  {
    "path": "/schedule/imports",
    "summary": "List Imports",
    "description": "",
    "columns": [
      "added",
      "error_key",
      "filename",
      "format",
      "id",
      "moved",
      "project_id",
      "redated",
      "removed",
      "started_at",
      "status",
      "unchanged",
      "version_id"
    ],
    "filters": []
  },
  {
    "path": "/schedule/links",
    "summary": "List Links",
    "description": "",
    "columns": [
      "due_on",
      "entity_id",
      "entity_type",
      "id",
      "is_blocking",
      "module",
      "ref_id",
      "relation"
    ],
    "filters": []
  },
  {
    "path": "/schedule/lookahead-groups",
    "summary": "List Lookahead Groups",
    "description": "",
    "columns": [
      "code",
      "id",
      "is_builtin",
      "name"
    ],
    "filters": []
  },
  {
    "path": "/schedule/lookaheads",
    "summary": "List Lookaheads",
    "description": "",
    "columns": [
      "end_date",
      "id",
      "label",
      "project_id",
      "published_at",
      "rolled_from_id",
      "start_date",
      "status",
      "version_id",
      "window_weeks"
    ],
    "filters": []
  },
  {
    "path": "/schedule/risk",
    "summary": "Schedule Risk",
    "description": "Activities held up by something outside the schedule (CM-SCH-07).",
    "columns": [
      "activity_code",
      "is_critical",
      "late_obligations",
      "name",
      "planned_finish",
      "planned_start",
      "ref_id",
      "total_float_days"
    ],
    "filters": []
  },
  {
    "path": "/schedule/sources",
    "summary": "List Sources",
    "description": "",
    "columns": [
      "engine",
      "external_ref",
      "id",
      "is_active",
      "kind",
      "last_synced_at",
      "name",
      "project_id"
    ],
    "filters": []
  },
  {
    "path": "/schedule/versions",
    "summary": "List Versions",
    "description": "Every version, newest first. None is ever removed (CM-SCH-03).",
    "columns": [
      "data_date",
      "float_source",
      "format",
      "id",
      "imported_at",
      "is_current",
      "kind",
      "label",
      "note",
      "parent_version_id",
      "project_id",
      "sequence"
    ],
    "filters": []
  },
  {
    "path": "/scope/divisions",
    "summary": "List Divisions",
    "description": "The project's division list, in number order, with how each is split.",
    "columns": [
      "covered_split_count",
      "id",
      "number",
      "project_id",
      "split_count",
      "title",
      "trade"
    ],
    "filters": []
  },
  {
    "path": "/scope/features",
    "summary": "List Features",
    "description": "The project's definable features of work, by code.",
    "columns": [
      "code",
      "created_at",
      "created_by_person_id",
      "csi_division_id",
      "description",
      "id",
      "project_id",
      "scope_split_id",
      "spec_section_id",
      "state",
      "title"
    ],
    "filters": []
  },
  {
    "path": "/scope/splits",
    "summary": "List Splits",
    "description": "The project's scope splits, by code.",
    "columns": [
      "code",
      "created_at",
      "created_by_person_id",
      "csi_division_id",
      "description",
      "id",
      "name",
      "project_id",
      "responsible_company_id",
      "state",
      "version"
    ],
    "filters": []
  },
  {
    "path": "/specs/books",
    "summary": "List Books",
    "description": "",
    "columns": [
      "area",
      "has_text_layer",
      "id",
      "issued_on",
      "name",
      "page_count",
      "project_id",
      "revision_label",
      "state"
    ],
    "filters": []
  },
  {
    "path": "/specs/extractions",
    "summary": "List Extractions",
    "description": "The runs this project has, newest first, without their items.",
    "columns": [
      "ai_executor",
      "ai_model",
      "ai_prompt_version",
      "awaiting_review",
      "based_on_id",
      "book_id",
      "created_at",
      "id",
      "items",
      "kind",
      "state"
    ],
    "filters": []
  },
  {
    "path": "/specs/offline-manifest",
    "summary": "Offline Manifest",
    "description": "What a field device must hold to read and mark up the specification",
    "columns": [
      "byte_size",
      "content_type",
      "page_from",
      "page_to",
      "revision_id",
      "section_id",
      "section_number",
      "sha256",
      "storage_key",
      "title"
    ],
    "filters": []
  },
  {
    "path": "/specs/sections",
    "summary": "List Sections",
    "description": "The current specification: one row per section, at its current revision.",
    "columns": [
      "division",
      "is_current",
      "page_from",
      "page_to",
      "revision_id",
      "revision_label",
      "section_id",
      "section_number",
      "source_storage_key",
      "superseded_notice",
      "title"
    ],
    "filters": []
  },
  {
    "path": "/submittals",
    "summary": "List Submittals",
    "description": "The submittal log, with the same cursor and view token as every log.",
    "columns": [
      "csi_division_id",
      "delivery_on",
      "disposition",
      "due_on",
      "due_on_source",
      "fabrication_start_on",
      "id",
      "lead_time_days",
      "manager_person_id",
      "number",
      "occurred_at",
      "project_id",
      "required_on_site_on",
      "responsible_company_id",
      "revision_no",
      "spec_section_id",
      "state",
      "submittal_type",
      "title"
    ],
    "filters": [
      {
        "name": "state",
        "choices": [
          "draft",
          "in_review",
          "returned",
          "closed"
        ]
      }
    ]
  },
  {
    "path": "/submittals/court",
    "summary": "My Court",
    "description": "Everything in this register waiting on the signed-in user.",
    "columns": [
      "action_key",
      "due_on",
      "number",
      "overdue",
      "reason_key",
      "state",
      "submittal_id",
      "title"
    ],
    "filters": []
  },
  {
    "path": "/submittals/register/candidates",
    "summary": "List Candidates",
    "description": "The proposals waiting on somebody, and where each one came from.",
    "columns": [
      "ai_confidence",
      "ai_model",
      "ai_prompt_version",
      "created_submittal_id",
      "id",
      "section_number",
      "source",
      "source_ref",
      "state",
      "submittal_type",
      "title",
      "trade",
      "was_corrected"
    ],
    "filters": [
      {
        "name": "state",
        "choices": [
          "proposed",
          "accepted",
          "rejected"
        ]
      }
    ]
  },
  {
    "path": "/submittals/workflow-templates",
    "summary": "List Templates",
    "description": "The project's saved submittal routes, the default first.",
    "columns": [
      "applies_to_mep",
      "id",
      "is_default",
      "is_retired",
      "name",
      "occurred_at",
      "parallel_versions",
      "project_id",
      "version_count"
    ],
    "filters": []
  },
  {
    "path": "/v1/deficiencies/",
    "summary": "List Deficiencies",
    "description": "The log, filtered. Every field in the record model is a filter.",
    "columns": [
      "affects_critical_path",
      "assignee_company_id",
      "assignee_person_id",
      "ball_in_court_action_key",
      "ball_in_court_company_id",
      "ball_in_court_person_id",
      "blocks_energization",
      "cause_code_id",
      "closed_by_person_id",
      "creator_person_id",
      "csi_division_id",
      "date_closed",
      "date_created",
      "days_to_resolve",
      "description",
      "dfow_id",
      "discovery_phase",
      "discovery_source",
      "display_number",
      "due_date",
      "equipment_id",
      "external_reference",
      "final_approver_id",
      "flag_for_review",
      "id",
      "is_punch_item",
      "is_rework",
      "location_id",
      "priority",
      "project_id",
      "punch_item_manager_id",
      "record_type",
      "recurrence_of_id",
      "reopen_count",
      "response",
      "rework_class",
      "rework_cost_direct",
      "rework_hours",
      "schedule_impact_days",
      "severity",
      "state",
      "status",
      "title"
    ],
    "filters": [
      {
        "name": "state",
        "choices": [
          "draft",
          "issued",
          "disputed",
          "ready_for_verification",
          "verified",
          "closed",
          "void"
        ]
      },
      {
        "name": "record_type",
        "choices": [
          "deficiency",
          "ccd"
        ]
      },
      {
        "name": "severity",
        "choices": [
          "critical",
          "major",
          "minor"
        ]
      },
      {
        "name": "discovery_phase",
        "choices": [
          "design",
          "procurement",
          "construction",
          "commissioning",
          "turnover",
          "warranty"
        ]
      }
    ]
  },
  {
    "path": "/v1/deficiencies/hotspots",
    "summary": "Read Hotspots",
    "description": "Where the same thing keeps going wrong, and the workbook's own charts.",
    "columns": [
      "average_days_to_resolve",
      "count",
      "direct_cost",
      "key",
      "label",
      "open_count"
    ],
    "filters": []
  },
  {
    "path": "/workforce/sources",
    "summary": "List Sources",
    "description": "",
    "columns": [
      "base_url",
      "credential_present",
      "credential_unreadable",
      "id",
      "import_origin",
      "imported_through",
      "is_active",
      "last_good_sync_at",
      "may_manage",
      "name",
      "project_id",
      "secret_name",
      "source_project_ref",
      "time_zone",
      "unlinked_at",
      "unlinked_by_id",
      "unlinked_reason",
      "vendor"
    ],
    "filters": []
  }
]

/** Every generated list under one module's route prefix. */
export function listsUnder(prefix: string): GeneratedList[] {
  return generatedLists.filter((list) => list.path.startsWith(prefix))
}

/**
 * Every module's "waiting on you" queue, from the document rather than a list.
 *
 * CM-RPT-01 describes one cross-module queue and each register publishes its
 * own slice of it at `<prefix>/court`. Which registers this instance loaded is
 * `modules.yml`'s business and changes per site, so the overview finds them the
 * same way the menu does — by asking what the application actually serves.
 * A hand-written list of five here is the drift #77 removed from the proxies.
 */
export function courtLists(): GeneratedList[] {
  return generatedLists.filter((list) => list.path.endsWith('/court'))
}
